import type { HouseholdInsightsApiResponse } from '../apiTypes';
import type { ReachKpis } from '../chartTypes';
import { parseKpi } from './utils';

export const parseReachKpis = (response: HouseholdInsightsApiResponse | undefined): ReachKpis => ({
  households: parseKpi(response?.totals?.households),
  users: parseKpi(response?.totals?.users),
  ctvDevices: parseKpi(response?.totals?.ctv_devices),
});
